import mixin from '../../mixins/Mixin';
export default function(editor, config = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  var image;
  domc.addType('dateHeure', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': 'Date et Heure',
          config: btoa(JSON.stringify(config)),
          tagName: 'div',
          selectable: true,
          resizable: {
            step: 0.2,
            minDim: 10,
            maxDim: 100,
            currentUnit: 1,
            autoHeight: true,
            tl: 1, // Top left
            tc: 0, // Top center
            tr: 1, // Top right
            cl: 0, // Center left
            cr: 0, // Center right
            bl: 1, // Bottom left
            bc: 0, // Bottom center
            br: 1, // Bottom right
          },
          copyable: true,
          traits: [
            {
              type: 'select',
              label: 'Choisir le format',
              name: 'source',
              options: [
                { value: 'Jour+JJ/MM/AAAA+hh:mm:ss', name: 'Mercredi 19/10/2016 10:24:00' },
                { value: 'Jour+JJ MMMM AAAA+hh:mm:ss', name: 'Mercredi 19 octobre 2016 10:24:00' },
                { value: '+JJ/MM/AAAA+hh:mm:ss', name: '19/10/2016 10:24:00' },
                { value: '+JJ MMMM AAAA+hh:mm:ss', name: '19 octobre 2016 10:24:00' },
                { value: '+JJ/MM+hh:mm:ss', name: '19/10 10:24:00' },
                { value: '+JJ MMMM+hh:mm:ss', name: '19 octobre 10:24:00' },
                { value: '+ +hh:mm:ss', name: '10:24:00' },
              ],
              changeProp: 1,
            },
          ],
          attributes: { style: 'display: none' },
          init() {
            this.listenTo(this.model, 'change:source', this.updateType);
          },
          updateType() {
            this.script();
          },
          script: function() {
            const config = `{[ config ]}`;
            const conf = JSON.parse(atob(config));
            let source = `{[ source ]}`;
            if (source.length < 1) source = 'Jour+JJ/MM/AAAA+hh:mm:ss';
            /* get Time  */
            function getDateTime() {
              var now = new Date();
              var hour = now.getHours();
              var minute = now.getMinutes();
              var second = now.getSeconds();

              if (hour.toString().length === 1) {
                hour = '0' + hour;
              }

              if (minute.toString().length === 1) {
                minute = '0' + minute;
              }

              if (second.toString().length === 1) {
                second = '0' + second;
              }

              var dateTime = hour + ':' + minute + ':' + second;
              return dateTime;
            }
            /* get day */
            function getDay() {
              var now = new Date();
              var days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
              var day = days[now.getDay()];
              if (source.split('+')[0] === 'Jour') return day;
              else return '';
            }
            function getFullDate() {
              var now = new Date();
              var year = now.getFullYear();

              var months = [
                'january',
                'february',
                'march',
                'april',
                'may',
                'june',
                'july',
                'august',
                'september',
                'october',
                'november',
                'december',
              ];
              var month = months[now.getMonth()];
              var day = now.getDate();
              var monthTra = conf.translate[month];
              var pad2 = function(n) {
                return n.toString().length === 1 ? '0' + n : '' + n;
              };
              var dayNum = pad2(day);
              var monthNum = pad2(now.getMonth() + 1);
              var JJ_MM_AAAA = dayNum + '/' + monthNum + '/' + year;
              var JJ_MM = dayNum + '/' + monthNum;
              var JJMMMMAAAA = day + ' ' + monthTra + ' ' + year;
              var JJMMMM = day + ' ' + monthTra;
              if (source.split('+')[1] === 'JJ/MM/AAAA') return JJ_MM_AAAA;
              if (source.split('+')[1] === 'JJ MMMM AAAA') return JJMMMMAAAA;
              if (source.split('+')[1] === 'JJ/MM') return JJ_MM;
              if (source.split('+')[1] === 'JJ MMMM') return JJMMMM;
              if (source.split('+')[1] === ' ') return ' ';
            }
            const id = this.id;
            //---------
            var c = document.getElementById(id).className.replace('gjs-comp-selected', '');
            var allDate = document.querySelectorAll('.' + c);
            // Refresh the day, date AND time together on every tick. Previously only
            // the time was updated inside the interval, so the date and weekday stayed
            // frozen on the previous day after midnight on long-running displays.
            function refreshDateHeure() {
              allDate.forEach(function(dateHeure) {
                var timeEl = dateHeure.querySelector('[data-js=dateHeure-time]');
                var fullDateEl = dateHeure.querySelector('[data-js=dateHeure-date]');
                var dayEl = dateHeure.querySelector('[data-js=dateHeure-day]');
                if (dayEl) dayEl.innerHTML = '' + getDay() + '';
                if (fullDateEl) fullDateEl.innerHTML = getFullDate();
                if (timeEl) timeEl.innerHTML = '' + getDateTime() + '';
              });
            }
            // Clear any previous timer for this widget so the script re-running
            // (e.g. on format change or re-render) doesn't stack multiple intervals.
            window.__dateHeureTimers = window.__dateHeureTimers || {};
            if (window.__dateHeureTimers[id]) {
              clearInterval(window.__dateHeureTimers[id]);
            }
            refreshDateHeure();
            window.__dateHeureTimers[id] = setInterval(refreshDateHeure, 1000);
          },
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName === 'div') {
            result = { type: 'dateHeure' };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      handleUpdate() {
        let tidesModel = editor
          .getComponents()
          .models.find(item => this.view && item.attributes.attributes.id === this.view.el.id);
        let localStorageComponents = JSON.parse(localStorage.getItem('gjs-components')).map(
          item => {
            if (this.view && item.attributes.id === this.view.el.id) {
              item = tidesModel;
            }
            return item;
          },
        );
        localStorage.setItem('gjs-js', editor.getJs());
        localStorage.setItem('gjs-html', editor.getHtml());
        localStorage.setItem('gjs-components', JSON.stringify(localStorageComponents));
      },
      getComponent() {
        this.model.set(
          'config',
          btoa(JSON.stringify(mixin.methods.getLangCode('display-dateHeure-plugin'))),
        );
        const comps = this.model.get('components');
        // Add a basic countdown template if it's not yet initialized
        const content = `
          <div id="dateHeure-grapes" class="emp-dateHeure-container">
           <span class="margin"data-js="dateHeure-day">Lundi </span>
           <span class="margin" data-js="dateHeure-date">  01 janvier </span>
           <span  class="margin" data-js="dateHeure-time" > --:--:-- </span>
          </div>
          `;

        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          setTimeout(() => {
            this.model.set('components', content);
          }, 1000);
        }
      },
      render(...args) {
        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length === 0) {
          this.getComponent(image);
        }
        this.updateScript();
        return this;
      },
    }),
  });
}



// WEBPACK FOOTER //
// ./src/plugins/dateHeure/components.js